import { Component } from 'react'
import AWSAPI from '../../../../common/AWSAPI'
import EstimationStore from '../../../libs/EstimationStore'
import Config from '../../../../Config'
import Window from '../../../../common/Window'

class EstimationManagement extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoaded: false,
      isEstimationCategoryLoaded: false,
      isEditingCategory: false,
    }
    this.initialize(props)
    this.apiUrl = Config.companyUserApiUrl.estimation
    this.userRole = 'companyUser'
  }
  initialize (props) {
    const {params} = props.match
    this.estimationType = params.estimationType
    this.isTemplate = (this.estimationType === 'template')
  }
  componentWillReceiveProps (nextProps) { // 同じコンポーネントを使っている見積書とテンプレート間の移動のため
    const {params} = this.props.match
    if (params.estimationType !== nextProps.match.params.estimationType) {
      this.initialize(nextProps)
      this.setState({isLoaded: false, isEstimationCategoryLoaded: false, isEditingCategory: false})
      if (this.componentWillMount) {
        this.componentWillMount()
      }
    }
  }
  loadEstimation (estimationId) {
    AWSAPI.getUserAttributes(this.userRole, (err, data) => {
      if (err) {
        // console.log(err)
      }
      const parentID = data.filter((e) => e.Name === 'custom:ParentID')[0].Value
      const onSuccess = (res) => {
        const estimation = res.body.data[0]
        if (!estimation) {
          // 削除か無効なID
          this.props.history.push('/company_user/estimation/' + this.estimationType)
          return false
        }
        estimation.estimationId = 'default'
        EstimationStore.setDataToStorage('estimation_default', estimation)
        EstimationStore.setData({
          currentEstimationId: 'default'
        })
        this.setState({
          isLoaded: true
        })
      }
      const paramsToPost = {
        command: 'get',
        parentID: parentID,
        estimationId: estimationId
      }
      AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToPost, onSuccess)
    })
  }
  loadEstimationCategoryList(targetEstimationType = null) {
    AWSAPI.getUserAttributes(this.userRole, (err, data) => {
      if (err) {
        console.log(err)
      }
      const parentID = data.filter((e) => e.Name === 'custom:ParentID')[0].Value;
      const onSuccess = (res) => {
        let categoryList = [{
          id: 'default',
          name: '未分類'
        }];
        if (res.body.data.length > 0) {
          const rawCategoryList = res.body.data[0].categoryList;
          if (Array.isArray(rawCategoryList)) {
            // レスポンスの categoryList が存在し、かつ配列である場合
            categoryList = rawCategoryList.map(item => {
              return {
                id: item.id,
                name: item.name
              };
            });
          }
        }
        this.setState({
          isEstimationCategoryLoaded: true,
          categoryList: categoryList
        });
      };

      const paramsToPost = {
        command: 'getCategory',
        parentID: parentID,
        estimationType: (targetEstimationType !== null) ? targetEstimationType : this.estimationType
      };
      AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToPost, onSuccess);
    });
  }
  loadEstimationListCount(estimationType, searchData, onSuccess) {
    AWSAPI.getUserAttributes(this.userRole, (err, data) => {
      if (err) {
        console.log(err)
      }
      const parentID = data.filter((e) => e.Name === 'custom:ParentID')[0].Value
      const params = {
        command: 'count',
        parentID: parentID,
        estimationType: estimationType,
        searchName: searchData.searchName,
        searchCategory: searchData.searchCategory,
        searchDateStart: searchData.searchDateStart,
        searchDateEnd: searchData.searchDateEnd,
      }
      AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
    })
  }
  loadEstimationListByEstimationTypePerPage(estimationType, pageNumber, searchData, onSuccess) {
    AWSAPI.getUserAttributes(this.userRole, (err, data) => {
      if (err) {
        console.log(err)
      }
      const pageSize = 10
      const parentID = data.filter((e) => e.Name === 'custom:ParentID')[0].Value
      const params = {
        command: 'perpage',
        parentID: parentID,
        estimationType: estimationType,
        pageSize: pageSize,
        pageNumber: pageNumber,
        searchName: searchData.searchName,
        searchCategory: searchData.searchCategory,
        searchDateStart: searchData.searchDateStart,
        searchDateEnd: searchData.searchDateEnd,
      }
      console.log(params)
      AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
    })
  }
  loadEstimationListByEstimationType(estimationType, onSuccess) {
    AWSAPI.getUserAttributes(this.userRole, (err, data) => {
      if (err) {
        console.log(err)
      }
      const parentID = data.filter((e) => e.Name === 'custom:ParentID')[0].Value
      const params = {
        command: 'query',
        parentID: parentID,
        estimationType: estimationType
      }
      AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
    })
  }
  sorter (a, b) {
    if (a.createDateTime < b.createDateTime) return 1
    if (a.createDateTime > b.createDateTime) return -1
    return 0
  }

  loadEstimationCount (searchData = []) {
    const onSuccess = (res) => {
      const estimationCount = res.body.data.count
      this.setState({
        estimationCount: estimationCount
      })
    }
    this.loadEstimationListCount(this.estimationType, searchData, onSuccess)
  }

  handlePageChange(event) {
    const page = Number(event.target.dataset.page);
    if (page > 0 && page <= this.state.totalPages) {
      this.loadEstimationList(page);
    }
  }

  loadEstimationList (pageNumber, searchData = []) {
    const onSuccess = (res) => {
      console.log(res.body)
      const estimationList = res.body.data && res.body.data.items ? res.body.data.items : null
      this.setState({
        isLoaded: true,
        isSearched: true,
        estimationList: estimationList
      })
    }
    this.loadEstimationListByEstimationTypePerPage(this.estimationType, pageNumber, searchData, onSuccess)
  }
  makeDemoDeta () {
    AWSAPI.getUserAttributes(this.userRole, (err, data) => {
      if (err) {
        // console.log(err)
      }
      const parentID = data.filter((e) => e.Name === 'custom:ParentID')[0].Value
      const onSuccess = (res) => {
        window.location.href = '/company_user/estimation/real'
      }
      const paramsToPost = {
        command: 'setDemoData',
        parentID: parentID
      }
      AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToPost, onSuccess)
    })
  }
  saveCategory () {
    AWSAPI.getUserAttributes(this.userRole, (err, data) => {
      if (err) {
        // console.log(err)
      }
      const parentID = data.filter((e) => e.Name === 'custom:ParentID')[0].Value
      const onSuccess = (res) => {
        this.setState({
          isEditingCategory: false
        })
      }
      const paramsToPost = {
        command: 'setCategory',
        parentID: parentID,
        estimationType: this.estimationType,
        estimationCategoryData: this.state.categoryList
      }
      AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToPost, onSuccess)
    })
  }
  saveEstimation (estimationData, action) {
    AWSAPI.getUserAttributes(this.userRole, (err, data) => {
      if (err) {
        // console.log(err)
      }
      const parentID = data.filter((e) => e.Name === 'custom:ParentID')[0].Value
      const onSuccess = (res) => {
        switch (action) {
          case 'update':
            Window.alert('更新しました', () => {
              this.props.history.push('/company_user/estimation/' + estimationData.estimationType + '/detail/' + estimationData.estimationId)
              Window.closeDialog()
            })
            break
          case 'createBlankEstimation':
            Window.alert('新しく作成しました', () => {
              this.props.history.push('/company_user/estimation/' + estimationData.estimationType + '/edit/' + estimationData.estimationId)
              Window.closeDialog()
            })
            break
          case 'copy':
            Window.alert('コピーを作成しました', () => {
              this.props.history.push('/company_user/estimation/' + estimationData.estimationType + '/edit/' + estimationData.estimationId)
              Window.closeDialog()
            })
            break
          default:
            break
        }
      }
      const command = (action === 'update') ? 'update' : 'add'
      const paramsToPost = {
        command: command,
        parentID: parentID,
        estimationId: estimationData.estimationId,
        estimationData: estimationData
      }
      AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToPost, onSuccess)
    })
  }
  deleteEstimation () {
    const {params} = this.props.match
    const estimationId = params.estimationId
    AWSAPI.getUserAttributes(this.userRole, (err, data) => {
      if (err) {
        // console.log(err)
      }
      const parentID = data.filter((e) => e.Name === 'custom:ParentID')[0].Value
      const onSuccess = (res) => {
        Window.alert('削除しました', () => {
          this.props.history.push('/company_user/estimation/' + this.estimationType)
          Window.closeDialog()
        })
      }
      const paramsToPost = {
        command: 'delete',
        parentID: parentID,
        estimationId: estimationId
      }
      AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToPost, onSuccess)
    })
  }
  zeroPack (text) {
    return ('0' + text).slice(-2)
  }
  separate (num) {
    return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
  }
  convKingaku (kingaku, decimalPlaces = 0, isShowingEmptyStringIfZero = false) {
    if (kingaku === null)kingaku = 0
    const value = Number(kingaku).toFixed(decimalPlaces)
    if (Number(value) === 0 && isShowingEmptyStringIfZero) {
      return ''
    }
    return isFinite(value) ? '¥' + this.separate(value) : ''
  }
  convSuuryou (suuryou, decimalPlaces = 1, isShowingEmptyStringIfZero = false) {
    const value = Number(suuryou).toFixed(decimalPlaces)
    if (value === 0 && isShowingEmptyStringIfZero) {
      return ''
    }
    return isFinite(value) ? this.separate(value) : ''
  }
  uuid () {
    let uuid = ''
    let i
    let random
    for (i = 0; i < 32; i++) {
      random = Math.random() * 16 | 0

      if (i === 8 || i === 12 || i === 16 || i === 20) {
        uuid += '-'
      }
      uuid += (i === 12 ? 4 : (i === 16 ? ((random & 3) | 8) : random)).toString(16)
    }
    return uuid
  }
}

export default EstimationManagement



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/abstract/EstimationManagement.js